// CONFIG API

// export const API_BASE_URL = 'http://localhost:8081/kengurAPI';
export const API_BASE_URL = 'https://imi.pmf.kg.ac.rs/kengur2/kengurAPI';
export const STUDENTS_API = `${API_BASE_URL}/api/students.php`;
export const USERS_API = `${API_BASE_URL}/api/users.php`;
export const COMPETITONS_API = `${API_BASE_URL}/api/competition.php`;

